<template>
    <div>
        <el-tabs v-model="selectedTabName" type="border-card" @tab-click="reDrawTab">
            <el-tab-pane :label="$t('message.manual_title_speechToText')" name="speechToText"></el-tab-pane>
            <el-tab-pane :label="$t('message.manual_title_translate')" name="translation"></el-tab-pane>
            <div v-if="selectedTabName=='speechToText'">
                <div class="manual-title">
                    <span v-t="'message.manual_speechToText_description1'"></span><br/>
                    <span v-t="'message.manual_speechToText_description2'"></span>
                </div>
                <div class="manual-body">
                    <table width="100%">
                        <tr class="manual-header-record" width="100%">
                            <td class="manual-record-item" width="25%" v-t="'message.manual_item_serviceName'"></td>
                            <td class="manual-record-item" width="25%" v-t="'message.manual_item_provider'"></td>
                            <td class="manual-record-item" width="40%" v-t="'message.manual_item_description'"></td>
                        </tr>
                        <tr>
                            <td class="manual-record-item">Azure Speech To Text</td>
                            <td class="manual-record-item">Microsoft corporation</td>
                            <td class="manual-record-item" v-html="$t('message.manual_speechToText_azure')">
                            </td>
                        </tr>
                        <tr v-if="showGoogleStt">
                            <td class="manual-record-item">Google Speech To Text</td>
                            <td class="manual-record-item">Google LLC</td>
                            <td class="manual-record-item" v-html="$t('message.manual_speechToText_google')">
                            </td>
                        </tr>
                        <tr>
                            <td class="manual-record-item">AmiVoice</td>
                            <td class="manual-record-item">Advanced Media,Inc.</td>
                            <td class="manual-record-item" v-html="$t('message.manual_speechToText_amivoice')">
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table width="100%">
                        <tr class="manual-header-record" width="100%">
                            <td colspan="5" class="manual-record-item" v-t="'message.manual_item_language'"></td>
                        </tr>
                        <div v-for="langRecord in languages">
                            <tr width="100%">
                                <td class="manual-item-language">{{ langRecord.lang1 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang2 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang3 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang4 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang5 }}</td>
                            </tr>
                        </div>
                    </table>
                </div>
            </div>
            <div v-if="selectedTabName=='translation'">
                <div class="manual-title">
                    <span v-t="'message.manual_translate_description1'"></span></br>
                    <span v-t="'message.manual_translate_description2'"></span>
                </div>
                <div class="manual-body">
                    <table width="100%">
                        <tr class="manual-header-record" width="100%">
                            <td class="manual-record-item" width="25%" v-t="'message.manual_item_serviceName'"></td>
                            <td class="manual-record-item" width="25%" v-t="'message.manual_item_provider'"></td>
                            <td class="manual-record-item" width="40%" v-t="'message.manual_item_description'"></td>
                        </tr>
                        <tr>
                            <td class="manual-record-item">Azure Translator Text</td>
                            <td class="manual-record-item">Microsoft corporation</td>
                            <td class="manual-record-item" v-html="$t('message.manual_translate_azure')">
                        </tr>
                        <tr>
                            <td class="manual-record-item">DeepL Pro Translator</td>
                            <td class="manual-record-item">DeepL GmbH</td>
                            <td class="manual-record-item" v-html="$t('message.manual_translate_deepl')">
                        </tr>
                        <tr>
                            <td class="manual-record-item">Google Translate</td>
                            <td class="manual-record-item">Google LLC</td>
                            <td class="manual-record-item" v-html="$t('message.manual_translate_google')">
                        </tr>
                    </table>
                    <br>
                    <table width="100%" style="padding-top:10px">
                        <tr class="manual-header-record" width="100%">
                            <td colspan="5" class="manual-record-item" v-t="'message.manual_item_language'"></td>
                        </tr>
                        <div v-for="langRecord in languages">
                            <tr width="100%">
                                <td class="manual-item-language">{{ langRecord.lang1 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang2 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang3 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang4 }}</td>
                                <td class="manual-item-language">{{ langRecord.lang5 }}</td>
                            </tr>
                        </div>
                    </table>
                </div>
            </div>
        </el-tabs>
    </div>
</template>

<script>
import commonUtil from './commonutil.js';

export default {
    props: {
        showGoogleStt: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            languages: [],
            languageListRecordCount: 0,
            selectedTabName: 'speechToText'
        }
    },
    created: function() {
        this.setLanguages();
    },
    methods: {
        setLanguages() {
            this.languages = [];
            let languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
            for (let i = 0; languageList.length / 5 + 1; i++) {
                let index = i * 5;
                if ((index + 5) <= languageList.length) {
                    if (this.$i18n.locale == 'ja') {
                        this.languages.push({ lang1: languageList[index].description, lang2: languageList[index+1].description, lang3: languageList[index+2].description, lang4: languageList[index+3].description, lang5: languageList[index+4].description})
                    } else {
                        this.languages.push({ lang1: languageList[index].description_en, lang2: languageList[index+1].description_en, lang3: languageList[index+2].description_en, lang4: languageList[index+3].description_en, lang5: languageList[index+4].description_en})
                    }
                } else if ((index + 4) <= languageList.length) {
                    if (this.$i18n.locale == 'ja') {
                        this.languages.push({ lang1: languageList[index].description, lang2: languageList[index+1].description, lang3: languageList[index+2].description, lang4: languageList[index+3].description, lang5: null})
                    } else {
                        this.languages.push({ lang1: languageList[index].description_en, lang2: languageList[index+1].description_en, lang3: languageList[index+2].description_en, lang4: languageList[index+3].description_en, lang5: null})
                    }
                } else if ((index + 3) <= languageList.length) {
                    if (this.$i18n.locale == 'ja') {
                        this.languages.push({ lang1: languageList[index].description, lang2: languageList[index+1].description, lang3: languageList[index+2].description, lang4: null, lang5: null})
                    } else {
                        this.languages.push({ lang1: languageList[index].description_en, lang2: languageList[index+1].description_en, lang3: languageList[index+2].description_en, lang4: null, lang5: null})
                    }
                } else if ((index + 2) <= languageList.length) {
                    if (this.$i18n.locale == 'ja') {
                        this.languages.push({ lang1: languageList[index].description, lang2: languageList[index+1].description, lang3: null, lang4: null, lang5: null})
                    } else {
                        this.languages.push({ lang1: languageList[index].description_en, lang2: languageList[index+1].description_en, lang3: null, lang4: null, lang5: null})
                    }
                } else if ((index + 1) <= languageList.length) {
                    if (this.$i18n.locale == 'ja') {
                        this.languages.push({ lang1: languageList[index].description, lang2: null, lang3: null, lang4: null, lang5: null})
                    } else {
                        this.languages.push({ lang1: languageList[index].description_en, lang2: null, lang3: null, lang4: null, lang5: null})
                    }
                } else {
                    break;
                }
            }
        }
    },
    watch: {
        '$i18n.locale'(newVal) {
            this.setLanguages();
        }
    }
}
</script>

<style scoped>
.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #ffffff;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #f6f6f6;
}
.el-tabs__nav-scroll {
    background: #f6f6f6;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #f6f6f6;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}

.manual-title {
    padding: 20px;
    font-size: 14px;
    color: #848991;
}
.manual-item-language {
    padding: 10px;
    width: 120px;
}
.manual-body {
    color: #848991;
    font-size: 14px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 10px;
}
</style>
